import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { Model } from 'backbone';
import { User } from '../../../models';

const leagueChannel = Radio.channel( 'league' );

/**
 * @desc Core Regeneration Bar View Class
 */
export default class CoreRegenerationBarView extends View {
	get template() {
		throw new Error("Need set template for child CoreRegenerationBarView class");
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			not_show_regeneration: '.js-not-show-regeneration',
			regeneration_bar:      '.js-regeneration-bar'
		};
	}

	events() {
		return {
			'click @ui.not_show_regeneration': 'disableShowRegeneration'
		};
	}

	initialize() {
		this.model = new Model( {
			is_regenerate: false
		} );

		this.user = User;

		this.initListeners();
	}

	initListeners() {
		this.listenTo( leagueChannel, 'check:regeneration:bar', this.checkRegenerationBar );

		return this;
	}

	checkRegenerationBar( is_regenerate ) {
		if ( is_regenerate ) {
			this.model = new Model( {
				is_regenerate: is_regenerate
			} );

			this.updateView();
		}

		return this;
	}

	disableShowRegeneration() {
		this.user.set( 'league_regenerate', 0 );
		this.user.updateUserData();

		this.getUI('regeneration_bar').hide();
	}

	/**
	 * Update view after all fetch data
	 */
	updateView() {
		this.render();
	}
}